import { get } from 'lodash';
import { PlacementType } from '@xbcb/shared-types';
import {
  TERMINAL_WORK_ORDER_TASK_STATUS,
  WorkOrderTaskType,
} from '@xbcb/work-order-types';
import { type WorkOrderTask, WorkOrderTaskStatus } from '__generated__/graphql';

type WorkOrderTaskCandidate = Pick<WorkOrderTask, 'deleted' | 'status'> & {
  definition: Pick<WorkOrderTask['definition'], 'workOrderTaskType'>;
};

// find a work order task on a work order that matches the task query string in the URL
export const findMatchingWorkOrderTask = (
  workOrderRecord: any,
  taskType: string,
) => {
  const workOrderTasks = get(workOrderRecord, 'tasks', []);
  const matchingTasks = workOrderTasks.filter(
    (task: WorkOrderTaskCandidate) => {
      const workOrderTaskType = get(task, 'definition.workOrderTaskType', '');
      return taskType === workOrderTaskType;
    },
  );

  // Hydra rework creates a second task of each type on the same work order.
  const hydraRepeatedTaskTypes: string[] = [
    WorkOrderTaskType.US_CONSUMPTION_ENTRY_BUILD_INVOICE,
    WorkOrderTaskType.US_CONSUMPTION_ENTRY_CONSOLIDATION_COMPLETION,
  ];
  const isHydraRepeatedTask =
    get(workOrderRecord, 'group.shipment.placementType') ===
      PlacementType.AOI_ORIGINAL && hydraRepeatedTaskTypes.includes(taskType);

  if (isHydraRepeatedTask) {
    return (
      matchingTasks.find(
        (task: WorkOrderTaskCandidate) =>
          !get(task, 'deleted') &&
          !TERMINAL_WORK_ORDER_TASK_STATUS.includes(get(task, 'status')),
      ) ||
      matchingTasks.find(
        (task: WorkOrderTaskCandidate) => !get(task, 'deleted'),
      )
    );
  }

  if (matchingTasks.length <= 1) {
    return matchingTasks[0];
  }

  // Apply non-COMPLETED logic only for specific task types
  const specialTaskTypes: string[] = [
    WorkOrderTaskType.US_IOR_CONTINUOUS_BOND_CHARGE_BOND_RENEWAL_EXCEPTION,
    WorkOrderTaskType.US_IOR_CONTINUOUS_BOND_VERIFY_RENEWAL_EXCEPTION,
  ];

  if (specialTaskTypes.includes(taskType)) {
    return (
      matchingTasks.find(
        (task: WorkOrderTaskCandidate) =>
          get(task, 'status') !== WorkOrderTaskStatus.COMPLETED,
      ) || matchingTasks[0]
    );
  }

  return matchingTasks[0];
};
